import { Button, CircularProgress, IconButton, Pagination } from '@mui/material'
import { Alert, Input,Select, Switch } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import DoneIcon from '@mui/icons-material/Done';
import TextArea from 'antd/es/input/TextArea';
import AddIcon from '@mui/icons-material/Add';
import { DeleteForever } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';

const Paginations = ({ EventsPerPage, totalEvents, paginate }) => {
  const [page, setPage] = React.useState(1);
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalEvents / EventsPerPage); i++) {
    pageNumbers.push(i);
  }
  
    const handleChange = (event, value) => {
        setPage(value);
        paginate(value)
    };

  
  return (
    <div className='pagination-buttons'>
        <Pagination count={pageNumbers.length}  page={page} onChange={handleChange} color="primary" />
    </div>
  );
};


export default function ShopAdmins({propsData}) {
    const location = useLocation()
    const [routes,setRoutes]=useState(location.pathname.split("/"))
    let [shopAdmins,GetShopAdmins]=useState([])
    let [AllUsers,GetAllUsers]=useState([])


    useEffect(()=>{
            axios.get(`${process.env.REACT_APP_URL}/api/shope/GetContributors/${routes[2]}`, //proxy uri
            {
               headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
               } 
            })
            .then(res=>{
              //console.log(res.data);
              GetShopAdmins(res.data)
            })
            .catch(error=>{
              //console.log(error);
            })

            axios.get(`${process.env.REACT_APP_URL}/api/shope/SearchUserToAdd/${routes[2]}`, //proxy uri
            {
               headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
               } 
            })
            .then(res=>{
              //console.log(res.data)
              GetAllUsers(res.data)
            })
            .catch(error=>{
             // console.log(error);
            })
      },[propsData.equilizer])

 
      
      let [showAddPage,handleShowAddPage]=useState(false)
      let [showRemovePage,handleShowRemovePage]=useState(false)

      let [value,handleValue]=useState("")
      let searchedValue=AllUsers.filter((e=>{
          return e.username?.toLowerCase().includes(value?.toLowerCase())
      }))

      let [selectedUser,handleSelectedUser]=useState({})
      //console.log(searchedValue,value,selectedUser);

      const openAddPage=()=>{
        handleShowAddPage(!showAddPage)
        handleSelectedUser({})
        handleValue("")
      }

      const canceled=()=>{
        handleSelectedUser({})
        handleValue("")
        handleShowAddPage(false)
      }

      let [loading,setLoading]=useState(false)
      let [error,GetError]=useState(false)
      let [success,GetSuccess]=useState(false)

      const AddUser=()=>{
        if(!selectedUser?.id){
          GetError("Please, select user first")
          setTimeout(()=>{
            GetError("")
          },4000)
          return
        }
        
        setLoading(true)
        let data={
          contributorId:selectedUser.id,
          shopId:routes[2]
        }

        axios.put(`${process.env.REACT_APP_URL}/api/shope/AddContributor`,data, //proxy uri
        {
           headers: {
              authorization:`Bearer ${ propsData.userData?.token }`,
              'Content-Type': 'application/json'
           } 
        })
        .then(res=>{
        //  console.log(res.data);
          setLoading(false)
          propsData.setEquilizer(propsData.equilizer+2)
          GetSuccess("Admin Successfylly added")
          setTimeout(()=>{
            GetSuccess("")
            handleShowAddPage(false)
          },3000)
        })
        .catch(error=>{
          setLoading(false)
          //console.log(error);
          GetError(error?.response?.data?.error||"Try again later")
          setTimeout(()=>{
            GetError("")
          },4000)
        })
      }

      const [currentPage, setCurrentPage] = useState(1);
      const ContributorPerPage =(8);
      
      const indexOfLastContributor = currentPage * ContributorPerPage;
      const indexOfFirstContributor = indexOfLastContributor - ContributorPerPage;
      const currentContributor = shopAdmins.slice(indexOfFirstContributor, indexOfLastContributor);
   
      const paginate = pageNumber => setCurrentPage(pageNumber);

  return (
    <div className='each-shop-admins'>
           <div className='each-shop-admins-intro'>
                <div>
                  <p>Admins/Contributors have full access to your shop, allowing them to perform various tasks and actions. However, they are restricted from accessing the "Setting" and "Admins" sections. This ensures that certain administrative functions and sensitive settings are only accessible to the shop owner.</p>
                  <p>As the shop owner, you have the authority to manage admins. You can ban or delete admins if necessary, giving you control over the user accounts and access privileges of the admins.</p>
                </div>

                <div className='each-shop-admins-intro-autority'>
                  <h4>Admins Authority (Editable)</h4>
                  <ul>
                    <li>Admins have the ability to create posts within the shop. They can write articles, announcements, or product descriptions to provide information or promote products. Additionally, they have the authority to delete the posts they have created.</li>
                    <li>Admins can create categories to organize products, content, or other items within the shop. Categories help users navigate and find specific items or information easily.</li>
                    <li>Admins also have the ability to delete categories that they own. This means they can remove entire sections or classifications from the shop if they deem it necessary.</li>
                    <li>Creating material is another authority granted to admins. They can add various types of materials such as product images, videos, or documents to enhance the user experience or provide additional information.</li>
                    <li>Similar to categories, admins have the authority to delete the materials they own. This allows them to remove specific content or media from the shop as needed.</li>
                  </ul>
                  <p><b>Note</b> that the authorities mentioned above for admins can be edited or modified by the shop owner, giving you the flexibility to adjust the level of access and control granted to admins based on your requirements.</p>
                </div>

           </div>
         
            <div className='each-shop-admins-delete-add'>
                 <div className='each-shop-admins-add'><Button onClick={openAddPage}>Add</Button></div>
            </div>

            <div className='each-shop-admins-All'>
                <table>
                      <thead>
                        <tr>
                          <th></th>
                          <th>user</th>
                          <th>Authority</th>
                          <th>Banned</th>
                          <th>Manage</th>
                          <th style={{color:"black"}}>Danger</th>
                        </tr>
                      </thead>
                      <tbody>
                          {currentContributor.map((e,index)=>{
                          return <EachContributorStatus propsData={propsData}  key={index} index={index} data={e}/>
                          })}
                      </tbody>
                  </table>
                  {shopAdmins.length>8&&<Paginations
                    EventsPerPage={ContributorPerPage}
                    totalEvents={shopAdmins.length}
                    paginate={paginate}
                  />}
            </div>
            
            {showAddPage&&<div className='each-shop-admins-create'>
                <div className='each-shop-admins-create-box'>
                {selectedUser?.username?
                  <div  className='each-shop-admins-create-box-selected-user'>
                            <div> <img src={selectedUser.profile} alt="Profile.pic" style={{borderRadius:"50%"}} width={100}/></div>
                            <div>{selectedUser.username}</div>
                    </div>
                  :<div>
                      <div><Input value={value} placeholder='search...' onChange={(e)=>handleValue(e.target.value)}/></div>
                      {value.length>0&&<div className='each-shop-admins-listOfUSers'>
                            {searchedValue.map(e=>{
                              return<EachUsers handleSelectedUser={handleSelectedUser} item={e} key={e._id}/>
                            })}
                      </div>}

                  </div>}
                  

                  {success&&<div><Alert message={success} type="success" showIcon /></div>}
                  {error&&<div><Alert message={error} type="error" showIcon /></div>}
                      
                  {loading?
                    <div style={{textAlign:"center",marginTop:"30px"}}><CircularProgress /></div> 
                    :
                    <>
                        {selectedUser?.username&&
                        <div className='each-shop-admins-create-add'>
                            <Button onClick={AddUser}>Add</Button></div>}
                        <div className='each-shop-admins-create-cancel'>
                            <Button onClick={canceled}>Cancel</Button>
                        </div>
                            
                    
                    </>
                  }


                </div>
            </div>}
            
    </div>
  )
}

const EachUsers=({item,handleSelectedUser})=>{

  return(
    <div onClick={()=>handleSelectedUser(item)} className='each-shop-admins-each-user'>
        <div> <img src={item.profile} alt="Profile.pic"  width={50}/></div>
        <div>{item.username}</div>
    </div>
  )

}

const EachContributorStatus=({data,index,propsData})=>{
  let [update,MakeUpdate]=useState(false)
  let [value,MakeValue]=useState(data.authority)
  let [banned,getBanned]=useState(data.isBanned)

  function onChange(checked) {
   // console.log(`switch to ${checked}`);
    getBanned(checked)
  }

  let options=[
    {
      value: 'category',
      label: 'category',
    },
    {
      value: 'all',
      label: 'all',
    },
    {
      value: 'post',
      label: 'post',
    },
  ]

  let [loading,setLoading]=useState(false)
  let [error,GetError]=useState(false)
  
  const updateDone=()=>{
    let values={
      contributorId:data._id,
      shopId:data.shopId,
      authority:value,
      status:banned,
    }
    //console.log(values);
    setLoading(true)
    axios.put(`${process.env.REACT_APP_URL}/api/shope/UpdateContributor`,values, //proxy uri
    {
       headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
             } 
    })
    .then(res=>{
      setLoading(false)
      GetError("")
      propsData.setEquilizer(propsData.equilizer+2)
      MakeUpdate(false)
    })
    .catch(error=>{
     // console.log(error);
      setLoading(false)
      GetError(error?.response?.data?.error||"Error Occured, please try again")
      setTimeout(()=>{
        GetError("")
      },5000)
    })
  }

  let[Done,HanldeDone]=useState(false)
  let [loadingDelete,setLoadingDelete]=useState(false)
  let [errorDelete,getErrorDelete]=useState(false)
  
  const RemoveUser=()=>{
    setLoadingDelete(true)
    let values={
      contributorId:data._id,
      shopId:data.shopId,
    }
    axios.put(`${process.env.REACT_APP_URL}/api/shope/RemoveContributor`,values, //proxy uri
    {
       headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
             } 
    })
    .then(res=>{
      setLoadingDelete(false)
      getErrorDelete("")
      propsData.setEquilizer(propsData.equilizer+2)
      MakeUpdate(false)
    })
    .catch(error=>{
      //console.log(error);
      setLoadingDelete(false)
      getErrorDelete(error?.response?.data?.error||"Error Occured, please try again")
      setTimeout(()=>{
        getErrorDelete("")
      },5000)
    })
  }
  
  //console.log(data.userId.username,data?.coupon&&data?.coupon?.amount*100);
    return(
    <tr >
      <td>{index+1}</td>
      <td style={{fontWeight:"500"}}>
            {data.userId.username}  
         <div style={{fontSize:"11px"}}>{moment(data.createdAt).format("ll")}</div>
      </td>
      <td> 
         {update?
           <Select
           style={{
             width: 100,
           }}
           value={value}
           onChange={(e)=>MakeValue(e)}
           options={options}
         />
        
           :
           <>
            {value}
            </>
        }
      </td>
      <td><Switch disabled={!update} checked={banned} onChange={onChange} /></td>
      <td>
        <IconButton onClick={()=>MakeUpdate(!update)}><EditIcon /></IconButton>
       {loading?  <CircularProgress size={15}/>: 
        <>
         {(value!==data.status&&update)&&<IconButton style={{color:"green"}}  onClick={updateDone}><DoneIcon/></IconButton>}
        </>}
        {error&&<div style={{color:"red",fontSize:"13px"}}>{error}</div>}
     </td>
     <td className='each-shop-admins-remove-button'>
      { Done?
          <>
           {loadingDelete?<CircularProgress size={20}/>:<Button onClick={RemoveUser}>Sure ?</Button>}
           {errorDelete&&<div style={{color:"red",fontSize:"13px"}}>{errorDelete}</div>}
          </>
        :<Button onClick={()=>HanldeDone(!Done)}>Remove</Button>}
      </td>
       
  </tr> 
    )
  }
  